// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M3.9996 2H10.9996V7.92353L11.3191 10H21.9996V22H16V16H14V22H1.83398L3.9996 7.92353V2ZM8.9996 8.07647V4H5.9996V8.07647L4.16521 20H7.9996V10H9.29552L8.9996 8.07647Z"}}]};

const Chimney2FilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'chimney-2-filled',
    ref,
    icon: element,
  },
));

Chimney2FilledIcon.displayName = 'Chimney2FilledIcon';

export default Chimney2FilledIcon;
